import request from '@/utils/request'

// 查询企业微信-外部客户信息列表
export function listExternalUser(query) {
    return request({
        url: '/wxCp/externalUser/list',
        method: 'get',
        params: query
    })
}

// 查询企业微信-外部客户信息详细
export function getExternalUser(id) {
    return request({
        url: '/wxCp/externalUser/' + id,
        method: 'get'
    })
}

// 新增企业微信-外部客户信息
export function addExternalUser(data) {
    return request({
        url: '/wxCp/externalUser',
        method: 'post',
        data: data
    })
}

// 修改企业微信-外部客户信息
export function updateExternalUser(data) {
    return request({
        url: '/wxCp/externalUser/update',
        method: 'post',
        data: data
    })
}

// 删除企业微信-外部客户信息
export function delExternalUser(id) {
    return request({
        url: '/wxCp/externalUser/delete/' + id,
        method: 'post'
    })
}
